// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper[data-v-8f49b470] {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
}
@media (max-width: 600px) {
.media-settings[data-v-8f49b470] .v--modal-box.v--modal {
    max-height: calc(var(--vh) * 100);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/MediaSettings.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;AACA;AACA;IACI,iCAAiC;AACrC;AACA","sourcesContent":[".wrapper[data-v-8f49b470] {\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  width: 100%;\n}\n@media (max-width: 600px) {\n.media-settings[data-v-8f49b470] .v--modal-box.v--modal {\n    max-height: calc(var(--vh) * 100);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
